<template>
  <exchange-log
    :exchanges="exchanges"
    :loading="loading"
    :loaded="loaded"
    title="Запросы к кассе и CRM по этому заказу"
    empty-hint="Записей нет. Оформление ходит в CRM за карточкой гостя, а в кассу — за расчётом корзины; у заказов, созданных до появления журнала, этих записей не будет."
    @refresh="refresh"
  ></exchange-log>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ExchangeLog from '@/components/exchange-log.vue'

export default {
  name: 'OrderIntegrationLog',
  components: { ExchangeLog },
  computed: {
    ...mapState('orderIntegrationLog', ['exchanges', 'loading', 'loaded']),
  },
  async mounted() {
    await this.refresh()
  },
  methods: {
    ...mapActions('orderIntegrationLog', ['fetchLog']),
    async refresh() {
      const { id } = this.$route.params
      await this.fetchLog(id)
    },
  },
}
</script>
